(() => {
const $e7158736ad5f49d9$export$7a5d735b2ab6389d = {
    copy: ()=>document.querySelectorAll('.socials__item--copy'),
    print: ()=>document.querySelectorAll('.socials__item--print'),
    toggle: ()=>document.querySelectorAll('.socials__item--share')
};
const $e7158736ad5f49d9$export$c6881760f06320dc = 'show';


const $bb29e4ae43c75184$export$96dcfe81b4f3e709 = ()=>window.showToast?.(window?.toastMessages?.copyLinkSuccess, 'success');
const $bb29e4ae43c75184$export$739bcfea9ba481d2 = ()=>window.showToast?.(window?.toastMessages?.copyLinkError, 'error');


// Open menu with several sharing options
(0, $e7158736ad5f49d9$export$7a5d735b2ab6389d).toggle().forEach((el)=>{
    el.addEventListener('focus', ()=>{
        el.classList.add((0, $e7158736ad5f49d9$export$c6881760f06320dc));
    });
});
// Copy URL functionality
(0, $e7158736ad5f49d9$export$7a5d735b2ab6389d).copy().forEach((el)=>{
    el.addEventListener('click', async ()=>{
        //! Temporary fix for Google Chrome on Windows
        const browser = navigator.userAgentData?.brands[0].brand;
        const os = navigator.userAgentData?.platform;
        const windowsChrome = 'Windows' === os && 'Google Chrome' === browser;
        if (!windowsChrome && navigator.canShare && navigator.canShare({
            url: window.location.href,
            title: document.title,
            text: document.title
        })) try {
            await navigator.share({
                title: document.title,
                text: document.title,
                url: window.location.href
            });
        } catch (error) {
            console.error('Error sharing content:', error);
            $73e4741056aed3c8$var$copyToClipboard();
        }
        else if (navigator.clipboard) $73e4741056aed3c8$var$copyToClipboard();
    });
});
const $73e4741056aed3c8$var$copyToClipboard = ()=>{
    if (navigator.clipboard) return navigator.clipboard.writeText(window.location.href).then((0, $bb29e4ae43c75184$export$96dcfe81b4f3e709), (0, $bb29e4ae43c75184$export$739bcfea9ba481d2));
    else console.error('Clipboard API not available');
};
// Print button
(0, $e7158736ad5f49d9$export$7a5d735b2ab6389d).print().forEach((el)=>{
    el.addEventListener('click', ()=>{
        window.print();
    });
});

})();
//# sourceMappingURL=socials.min.js.map
